import {customElement, bindable, inject} from 'aurelia-framework';

@customElement("sio-tab-log")
export class TabContentLog {
    @bindable object;
    @bindable tab;
}
